import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";

// Action Types
export const WEALTH_GUIDED_REBALANCES_SUBMIT = "WGR/SUBMIT";
export const WEALTH_GUIDED_REBALANCES_SUBMIT_SUCCESS = "WGR/SUBMIT/SUCCESS";
export const WEALTH_GUIDED_REBALANCES_SUBMIT_FAILURE = "WGR/SUBMIT/FAILURE";

// Action Creators
export const wealthGuidedRebalancesSubmit = (tier, payload) => ({
  type: WEALTH_GUIDED_REBALANCES_SUBMIT,
  tier,
  payload,
});

export const wealthGuidedRebalancesSubmitSuccess = (data, tier) => ({
  type: WEALTH_GUIDED_REBALANCES_SUBMIT_SUCCESS,
  data,
  tier,
});

export const wealthGuidedRebalancesSubmitFailure = (error, tier) => ({
  type: WEALTH_GUIDED_REBALANCES_SUBMIT_FAILURE,
  error,
  tier,
});

// Sagas
function* submitWealthGuidedRebalances(action) {
  try {
    const { tier, payload } = action;

    const response = yield axios.put(
      `${apiURL}/wealth-series/guided-rebalances?tier=${tier}`,
      payload,
      { withCredentials: true },
    );

    yield put(wealthGuidedRebalancesSubmitSuccess(response.data, tier));
  } catch (error) {
    yield put(wealthGuidedRebalancesSubmitFailure(error));
  }
}

function* listenWealthGuidedRebalancesSubmit() {
  yield takeEvery(
    WEALTH_GUIDED_REBALANCES_SUBMIT,
    submitWealthGuidedRebalances,
  );
}

// Root Saga
export function* saga() {
  yield all([fork(listenWealthGuidedRebalancesSubmit)]);
}

const INIT_STATE = {
  guidedRebalances: {},
  loading: {},
  error: {},
};

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case WEALTH_GUIDED_REBALANCES_SUBMIT:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.tier]: true,
        },
        error: {
          ...state.error,
          [action.tier]: null,
        },
      };
    case WEALTH_GUIDED_REBALANCES_SUBMIT_SUCCESS:
      return {
        ...state,
        guidedRebalances: {
          ...state.guidedRebalances,
          [action.tier]: action.data,
        },
        loading: {
          ...state.loading,
          [action.tier]: false,
        },
        error: {
          ...state.error,
          [action.tier]: null,
        },
      };
    case WEALTH_GUIDED_REBALANCES_SUBMIT_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.tier]: false,
        },
        error: {
          ...state.error,
          [action.tier]: action.error,
        },
      };
    default:
      return state;
  }
};

export default reducer;
